import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewClient from "../view";
import ViewClientUser from "./view";
import EditClientUser from "./edit";
import { MODULE_CLIENT } from "variables/constants";

const clientUserRoutes = [
	generateCRUDRoutes({
		mainTitle: "Client Users",
		basePath: "clients/:clientId/client-users",
		mainComponent: <ViewClient />,
	    layout: "/console",	   
	    subTitle:"Client User",
	    viewComponent: <ViewClientUser />,
	    createComponent: <EditClientUser />,
	    editComponent: <EditClientUser />,
		level:3,
		moduleId: MODULE_CLIENT,   
	})
]

export default clientUserRoutes;